/**
 * ** WuBook **
 *
 * @exports partnership_42
 * @category partnerships
 */

function factory({ window, document, thn }) {

  const partnership = {};

  /**
     * @memberOf module:partnership_42
     */
  partnership.getId = function getId() {
    return '42';
  };

  /**
     * @memberOf module:partnership_42
     */
  function getSiteIdFromUrl() {
    return thn.parseUrlParameter('lcode') || thn.parseUrlParameter('ep');
  }

  function getSiteIdFromObj() {
    const lcode = window.WuBook && window.WuBook.lcode && window.WuBook.lcode.toString();
    return lcode || thn.objectGet(window.__KWIGG_CDATA__ || {}, 'epid');
  }

  /**
     * @memberOf module:partnership_42
     */
  partnership.check = function check() {
    return !!(
      getSiteIdFromUrl() || getSiteIdFromObj()
    );
  };

  partnership.getSiteId = function getSiteId() {

    const result = {
      externalId: getSiteIdFromUrl() || getSiteIdFromObj(),
    };

    return result;
  };

  return partnership;

}

export { factory };
